import React from "react";
import { Helmet } from "react-helmet-async";
import { Link } from "react-router-dom";
import { privacyPolicyData as data } from "../data/candidate-explainer-privacy-policy.data";
import { useRedirectUrl } from "../hooks/useRedirectUrl";
import styles from "./candidate-explainer.module.scss";
import "./terms-of-service.scss";

export function TermsOfService() {
  const redirect = useRedirectUrl();

  return (
    <>
      <Helmet>
        <title>Sapia | Privacy Policy</title>
        <meta
          http-equiv="refresh"
          content="0; url=https://sapia.ai/terms-of-service/"
        />
      </Helmet>
{/*       
      <div className={`${styles["candidateExplainer"]} candidate-container`}>
        <div className={styles["explainerBanner"]}>
          <ul className={styles["landingBreadcrumbs"]}>
            {data.header_section.breadcrums.map((b, i) => {
              switch (i) {
                case 0:
                  return (
                    <li className={styles["candidateBtn"]} key={i}>
                      <a href={redirect}>{b.label}</a>
                    </li>
                  );
                default:
                  return (
                    <li key={i}>
                      <Link to={b.link}>{b.label}</Link>
                    </li>
                  );
              }
            })}
          </ul>
        </div>

        <div className="container terms-of-service">
          <p>
            <b>
              Sapia Pty Ltd (“Sapia”, “we”, “our”, or “us”) is a software
              provider, who offers talent intelligence software to our clients.
            </b>
          </p>
          <p>
            When applying for roles, especially with big companies, candidates
            often can’t fully express why they would be great for the job. With
            thousands of CVs to review, great candidates like you can get
            missed. That’s why we launched Sapia. To give every candidate a fair
            go and the chance to be interviewed and assessed equally. Our
            clients shared this objective and chose us as a partner to provide
            you with an online interview or questionnaire.
          </p>
          <p>
            Whilst interviewing can be daunting, we want to make sure the
            experience is as smooth as possible. So by starting your interview
            or questionnaire, you agree that you will comply with our “Terms”
            set out below. We've tried to make our Terms easy to read and
            understand — avoiding jargon wherever we can. However, please read
            them carefully because they're legally binding.
          </p>
          <p>
            Whilst this document focuses more on the ‘legal side’, our{" "}
            <a
              href="https://me.predictivehire.com/"
              target="_blank"
              rel="noopener noreferrer"
            >
              candidate hub
            </a>{" "}
            sets out more details of the interview process.
          </p>
          <h3 id="how-can-you-use-firstinterview-">What do I need to know?</h3>

          <p>
            <b>You must maintain a secure internet connection.</b> We try to
            save all your information as you progress through an interview.
            Still, suppose you lose access due to a disruption in your
            telecommunications or internet service. In that case, we will not be
            liable for any losses suffered.
          </p>

          <p>
            <b>You must keep your details safe.</b> Be careful to keep your
            interview URL(s) confidential. If you think someone else might have
            access to your interview details, you must contact us as soon as
            possible.
          </p>

          <p>
            <b>You must not attempt to gain unauthorised access.</b> Whether
            this is to the interview platform itself, the server on which Sapia
            is managed, or any server, computer or database connected to Sapia’s
            products.
          </p>

          <p>
            <b>Do not reverse engineer Sapia</b> or otherwise attempt to derive
            or obtain information about our products’ functioning, manufacture,
            or operation. You must not attempt to modify, translate, or create
            derivative works based on our products. You cannot copy, rent,
            lease, distribute, pledge, assign or otherwise transfer or encumber
            rights to any of our products.
          </p>

          <p>
            <b>
              You are responsible for ensuring you have virus protection
              software.
            </b>
            Unfortunately, we cannot guarantee that our Website will be secure
            or free from bugs or viruses.
          </p>

          <p>
            <b>Our products are for non-commercial use only.</b> You acknowledge
            and agree that you can only use our products to find employment. If
            you are a corporate client, complete a demo or testing of our
            products. You may not transfer, sell, distribute, lease, sublease,
            assign or licence Sapia to any third parties.
          </p>

          <h3>What about my responses during the interview?</h3>
          <ul>
            <li>
              All responses you give through Sapia’s products must:
              <ul>
                <li>be accurate (where it states facts);</li>
                <li>be genuinely held (where it states opinions); </li>
                <li>be your own work (not plagiarised); and </li>
                <li>comply with applicable law.</li>
              </ul>
            </li>
            <li>
              In addition, your responses must not be:
              <ul>
                <li>
                  defamatory of anyone or could bully, insult, intimidate,
                  discriminate or humiliate someone;{" "}
                </li>
                <li>unlawful; </li>
                <li>promote sexually explicit material; </li>
                <li>promote violence; </li>
                <li>infringe any copyright, database right or trade mark; </li>
                <li>likely to deceive; </li>
                <li>
                  known to contain any advertising or promotion for another
                  company and/or site; and/or{" "}
                </li>
                <li>
                  known to introduce viruses, trojans, worms, logic bombs or
                  other material that is malicious or technologically harmful.
                </li>
              </ul>
            </li>
          </ul>
          <h3 id="our-role-during-your-use-of-first-interview">
            What is Sapia’s role?
          </h3>
          <p>
            Each of our products is provided to you as is. We will not give any
            guarantees or protections as to its performance or your use of it.
          </p>

          <p>
            Our products contain links to other sites and resources provided by
            third parties. These are provided for your information only. They
            should not be interpreted as approval by us of those linked websites
            or information you may obtain from them.
          </p>

          <p>
            We do not guarantee that our website or any content will always be
            available or uninterrupted. We may suspend or withdraw or restrict
            the availability of all or any part of our website for business and
            operational reasons. We will try to give you reasonable notice of
            any suspension or withdrawal.
          </p>

          <p>
            We may suspend or withdraw any of our products at any time. We do
            not guarantee that our Platform will always be available or be
            uninterrupted. We may suspend, withdraw, or restrict the
            availability of all or any part of Sapia for business and
            operational reasons.
          </p>

          <p>
            If we discover that you have breached any of our terms, we may take
            the following action/s:
          </p>

          <ul>
            <li>
              contact your recruiter or employer directly about the breach;
            </li>
            <li>
              immediately withdraw your right to use our products, either
              temporarily or permanently;{" "}
            </li>
            <li>instigate legal action against you; and/or</li>
            <li>
              disclose such information to law enforcement authorities as we
              reasonably feel is necessary or as required by law.
            </li>
          </ul>

          <h3 id="intellectual-property">
            Who owns the intellectual property?
          </h3>
          <p>
            Sapia Pty Ltd is the owner or the licensee of all intellectual
            property rights in our products. This includes any modifications and
            improvements, whether made by us or suggested by you. Those works
            are protected by copyright laws and treaties around the world. All
            such rights are reserved.{" "}
          </p>

          <p>
            We provide you with a worldwide, non-exclusive, non-transferable,
            non-sublicensable, revocable, limited-term licence for personal use
            only, allowing you to use our products to undertake your interview
            (if you are a candidate). Furthermore, if you are a corporate client
            or prospect, you can complete a demo or testing of our products as
            per these Terms.
          </p>

          <h3 id="what-do-we-do-with-your-personal-data-">
            How do you use my personal data?
          </h3>

          <p>
            We will process your data on behalf of the organisation where you’ve
            applied for a job. For more information, please visit our{" "}
            <a
              href="https://me.predictivehire.com/candidate-explainer-privacy-policy/"
              target="_blank"
              rel="noopener noreferrer"
            >
              Privacy Policy
            </a>
            .
          </p>

          <h3 id="liability">Are you liable for any losses?</h3>
          <p>
            <b>We do not limit any losses that we are not allowed to limit.</b>{" "}
            We do not exclude or limit in any way our liability to you where it
            would be unlawful to do so, for example, death or personal injury
            caused by our negligence.
          </p>

          <p>
            We are not responsible for any loss or damage that is not
            foreseeable. Loss or damage is foreseeable if it is apparent that it
            will happen. Alternatively, if at the time these terms apply, both
            you and we knew it might happen, for example, if you discussed it
            with us.
          </p>

          <p>
            <b>
              If you are using our products as a candidate, we provide our
              website
            </b>
            for personal use only. This means that, even if we don't follow
            these Terms, we're not responsible for any business interruption or
            loss of business earnings or opportunities.
          </p>

          <h3 id="general">Is there anything else I need to know?</h3>
          <p>
            As our products evolve, we might have to make changes to these
            Terms. We will do this by uploading the latest version with a date
            confirming when they went live. If you carry on using our services
            after we make changes to the Terms, it means you've agreed to them.
            The new version of the Terms will replace the old version.
          </p>

          <p>
            In the future, we might transfer the rights and obligations we have
            under these Terms to another company, provided it doesn't materially
            affect your rights. However, you can't transfer your rights or
            obligations under these Terms to anybody else. This is because these
            Terms are personal to you — and nobody else is entitled to benefit
            from them.
          </p>

          <h3>What laws apply to these terms?</h3>
          <p>
            These Terms are governed by English law, and the English courts will
            have jurisdiction over any claim.
          </p>

          <h3>What if I have any questions?</h3>

          <p>
            If you need more information about our products, please visit our{" "}
            <a href="https://me.predictivehire.com/" target="__blank">
              candidate hub
            </a>{" "}
            first, where you can find answers to frequently asked questions.
          </p>

          <p>
            If you need further help and wish to reach out to us, you can
            contact us at{" "}
            <a href="mailto:support@predictivehire.com">
              support@predictivehire.com
            </a>{" "}
            .
          </p>

          <p>We wish you the best of luck with your interview!</p>
        </div>

        <div className="interview-support-section explainer-padding">
          <div className="container">
            <div className="text-center">
              <h3 className="blue-title">
                {data.contact_section.section_title}
              </h3>
              <button
                type="button"
                className="btn-help"
                style={{ cursor: "pointer" }}
              >
                {data.contact_section.button_label}
              </button>
              <p>
                <a
                  href={data.contact_section.privacy_button_link}
                  className="black-link"
                >
                  {data.contact_section.privacy_button_label}
                </a>
              </p>
            </div>
          </div>
        </div>
      </div> */}
    </>
  );
}
